import apiClient from "../utils/apiClient";

// Category API endpoints
const categoryApi = {
  // Get all categories and subcategories
  getAllCategories: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const endpoint = queryString
        ? `/category/list?${queryString}`
        : "/category/list";
      return await apiClient(endpoint, "GET");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Add a new category
  addCategory: async (categoryData) => {
    try {
      return await apiClient("/category/add-category", "POST", categoryData);
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Edit an existing category
  editCategory: async (id, categoryData) => {
    try {
      return await apiClient(
        `/category/edit-category/${id}`,
        "PUT",
        categoryData
      );
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Delete a category (soft delete)
  deleteCategory: async (id) => {
    try {
      return await apiClient(`/category/delete-category/${id}`, "DELETE");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Add a new subcategory
  addSubCategory: async (subCategoryData) => {
    try {
      return await apiClient(
        "/category/add-subcategory",
        "POST",
        subCategoryData
      );
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Edit an existing subcategory
  editSubCategory: async (id, subCategoryData) => {
    try {
      return await apiClient(
        `/category/edit-subcategory/${id}`,
        "PUT",
        subCategoryData
      );
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Delete a subcategory (soft delete)
  deleteSubCategory: async (id) => {
    try {
      return await apiClient(`/category/delete-subcategory/${id}`, "DELETE");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },
};

export default categoryApi;
